<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row">
    <div *ngIf="isError" class="col-xl-12 block-style">
        <div class="alert alert-danger" role="alert">
            {{errorMessage}}
        </div>
    </div>

    <div *ngIf="!isError" class="col-xl-8 no-padding">
        <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
            <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                <span style="float:left">FED # {{detail.id}}</span>
                <span style="float:right">{{detail.createdDate | date :'medium'}}</span>
            </h6>

        </div>
        <div class="block-style" style="margin-bottom:20px;border-top-left-radius: 0; border-top-right-radius: 0;">
            <div class="container">
                <div class="row t30-padding">
                    <div class="col-md-12 col-sm-12 no-padding">

                        <div class="col-md-12 col-sm-12 col-xs-12  no-padding">
                            <h4 style="margin-left:5px">{{detail.subject}}</h4>
                            <pre style="background-color: white" [innerHTML]="detail.message"></pre>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
            <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                Replies
            </h6>

        </div>
        <div class="block-style" style="margin-bottom:20px;border-top-left-radius: 0; border-top-right-radius: 0;">
            <div class="container">
                <div class="row t30-padding">
                    <div class="col-md-12 col-sm-12 no-padding">

                        <div class="col-md-12 no-padding" style="margin-top:10px !important;">
                            <div style="" class="col-md-12 no-padding">

                                <div class="row">
                                    <div class="col-md-12 col-sm-12 col-xs-12 no-padding">
                                        <mat-accordion class="example-headers-align">
                                            <mat-expansion-panel style="margin-bottom:10px;" *ngFor="let item of replies; let i = index">
                                                <mat-expansion-panel-header>
                                                    <mat-panel-title>
                                                        <div class="col-md-12 col-sm-12 col-xs-12 no-padding">
                                                            <span>{{i + 1}}: </span>
                                                            <img style="width: 30px;height:30px; border-radius:50%" class="message-avatar" src="{{item.replyPortalUser.contactLogo}}" alt="">
                                                            <a style="padding-left:5px; font-size:14px;color:#252525"> {{item.replyPortalUser.firstName}} {{item.replyPortalUser.lastName}} </a>
                                                            <small style="float: right"> {{item.createdDate | date:'medium'}} </small>
                                                        </div>

                                                    </mat-panel-title>
                                                </mat-expansion-panel-header>

                                                <pre style="background-color: transparent;font-size:14px !important; color:#252525" [innerHTML]="item.reply"></pre>

                                            </mat-expansion-panel>

                                        </mat-accordion>
                                    </div>
                                    <div class="col-md-12 col-sm-12 col-xs-12 no-padding">
                                        <textarea placeholder="Write your message here..." style="padding:10px !important;    font-size: 14px !important; margin-bottom: 10px;   border-color: lightgrey;border-bottom: 2px solid #00A6B6;width:100%;height:100px" class="summernote" [(ngModel)]="description"></textarea>
                                    </div>
                                    <div class="form-group col-md-12 col-sm-12 col-xs-12 no-padding">
                                        <button [disabled]="btnVerifyDisabled" style="float: right;" class="btn mygistec-main-btn" (click)="addFeedbackReply()">{{btnVerifyText}}</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div *ngIf="!isError" class="col-xl-4" style="padding-right: 0px; padding-left: 30px;">
        <div class="row" style="margin-bottom:15px !important">
            <!--Request details-->
            <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
                <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                    <span style="float:left">Feedback Details</span>
                </h6>
            </div>
            <div class="col-xl-12 block-style" style="border-top-right-radius:0px; border-top-left-radius:0px">
                <div class="row small-section-content">
                    <div class="col-xl-12 no-padding" style="margin-top:0px">
                        <div style="font-weight: bold;font-size: 17px;">Type</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">
                            {{detail.topic}}
                        </p>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:10px">
                        <div style="font-weight: bold;font-size: 17px;">Category</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">
                            {{detail.subTopic}}
                        </p>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;font-size: 17px;">Requester name</div>
                        <div style="margin-top:10px">
                            <img [src]="detail.requestedContactLogo" style="width: 30px; height:30px; border-radius: 50%;" />
                            <span style="margin: 0px; margin-top: 5px; font-size: 14px !important; color: #bdbdbd; padding-left: 10px;">{{detail.requestedName}}</span>
                        </div>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;font-size: 17px;">Requester account</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{detail.requestedOrganization}}</p>
                    </div>

                </div>
            </div>

        </div>

    </div>

</div>

